import styled from "styled-components";

export const Container = styled.div`
  background-color: #DCFFF8;
  padding: 116px 0 32px;
  width: 100%;

@media (max-width: 768px) {
  padding: 104px 32px 32px;
  }
`

export const Display = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  gap: 16px;
`

export const Price = styled.div`
  align-items: center;
  background-color: #00A687;
  border-radius: 8px;
  box-shadow: 0px 0px 24px 0px #00000029;
  color: #FFFFFF;
  display: flex;
  flex: 1 100%;
  font-size: 24px;
  font-weight: 700;
  justify-content: space-evenly;
  text-align: center;
  padding: 8px 24px;

  span {
    color: #A6FF00;
    font-size: 32px;
    line-height: 36.77px;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    font-size: 16px;
    line-height: 24px;
    padding: 8px;

    span {
      display: block;
      font-size: 32px;
      line-height: 36.77px;
      margin-top: 8px;
    }
  }
`